import React from 'react';
import { Typography } from 'antd';
import type { AgentMessage } from '../../types/agent';
import { fct } from '../../fct/tokens/tokens';

const { Text } = Typography;

interface AgentMessageBubbleProps {
  message: AgentMessage;
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    display: 'flex',
    marginBottom: 12,
  },
  wrapperUser: {
    justifyContent: 'flex-end',
  },
  wrapperAgent: {
    justifyContent: 'flex-start',
  },
  bubble: {
    maxWidth: '75%',
    padding: '10px 14px',
    borderRadius: fct.radio.tarjeta,
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
  },
  bubbleUser: {
    backgroundColor: fct.marca['verde-oscuro'],
    color: fct.tinta.inversa,
    borderBottomRightRadius: fct.radio.micro,
  },
  bubbleAgent: {
    backgroundColor: fct.superficie.hundida,
    color: fct.tinta['900'],
    borderBottomLeftRadius: fct.radio.micro,
  },
};

const AgentMessageBubble: React.FC<AgentMessageBubbleProps> = ({ message }) => {
  const isUser = message.role === 'user';
  return (
    <div
      style={{
        ...styles.wrapper,
        ...(isUser ? styles.wrapperUser : styles.wrapperAgent),
      }}
    >
      <div
        style={{
          ...styles.bubble,
          ...(isUser ? styles.bubbleUser : styles.bubbleAgent),
        }}
      >
        <Text style={{ color: 'inherit', fontSize: 14 }}>{message.text}</Text>
      </div>
    </div>
  );
};

export default AgentMessageBubble;
